module.exports = __webpack_public_path__ + "img/logo.545d70cf.png";